"use client";
import { InfoCircleOutlined } from "@ant-design/icons";
import CalendarIcon from "@untitled-ui/icons-react/build/esm/Calendar";
import { Col, DatePicker, Form, Input, Row, Select, Tooltip } from "antd";

import ChevronDown from "@untitled-ui/icons-react/build/esm/ChevronDown";
import dayjs from "dayjs";
import { useEffect } from "react";
import { BOM } from "../../../../../services/definedMethod";

const Option = Select;

const EditProductInformationForm = (props) => {
  const {
    onFinish,
    form,
    markStepAsModified,
    stepIndex,
    productCategoryOptions,
    currencyOptions,
    issueTypeOptions,
    bondTypeOptions,
    onCurrencyChange,
    custodianOptions,
    accountingClassificationsOptions,
  } = props;
  const selectedCurrency = Form.useWatch("currency", form);

  useEffect(() => {
    if (onCurrencyChange && selectedCurrency) {
      onCurrencyChange(selectedCurrency);
    }
  }, [selectedCurrency]);

  const startOfYear = dayjs().startOf("year");
  const today = dayjs();

  return (
    <div>
      <h1
        style={{
          fontSize: "24px",
          fontWeight: "bold",
          margin: 0,
          marginBottom: "24px",
        }}
      >
        Product Information
      </h1>

      <Form
        className="custom-form"
        layout="vertical"
        onFinish={onFinish}
        form={form}
        onValuesChange={() => markStepAsModified(stepIndex)}
        style={{ width: "100%" }}
      >
        <Row>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <span>
                  Product Code
                  <Tooltip title="Enter the unique product code">
                    <InfoCircleOutlined
                      style={{
                        marginLeft: "4px",
                        color: "#667085",
                      }}
                    />
                  </Tooltip>
                </span>
              }
              name="productCode"
              rules={[
                {
                  required: true,
                  message: "Product code cannot be empty",
                },
                {
                  pattern: /^[A-Z0-9]+$/,
                  message:
                    "Product code must contain only uppercase letters and numbers",
                },
                {
                  max: 5,
                  message: "Product code cannot be more than 5 characters",
                },
              ]}
            >
              <Input
                className="bond-input"
                style={{ height: 44 }}
                placeholder="Enter product code"
              />
            </Form.Item>
          </Col>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <span>
                  Product Name
                  <Tooltip title="Enter the product name">
                    <InfoCircleOutlined
                      style={{
                        marginLeft: "4px",
                        color: "#667085",
                      }}
                    />
                  </Tooltip>
                </span>
              }
              name="productName"
              rules={[
                {
                  required: true,
                  message: "Product Name cannot be empty",
                },
                {
                  min: 3,
                  message: "Product Name cannot be less than 3 characters",
                },
              ]}
            >
              <Input
                className="bond-input"
                style={{ height: 44 }}
                placeholder="Enter product name"
              />
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <span>
                  Product Category
                  <Tooltip title="Select the product category">
                    <InfoCircleOutlined
                      style={{
                        marginLeft: "4px",
                        color: "#667085",
                      }}
                    />
                  </Tooltip>
                </span>
              }
              name="productCategory"
              rules={[
                {
                  required: true,
                  message: "Please select product category",
                },
              ]}
            >
              <Select
                placeholder="Select product category"
                style={{ height: 44 }}
                suffixIcon={<ChevronDown color="#667085" width={20} />}
                options={productCategoryOptions}
              />
            </Form.Item>
          </Col>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <span>
                  Currency
                  <Tooltip title="Select the currency">
                    <InfoCircleOutlined
                      style={{
                        marginLeft: "4px",
                        color: "#667085",
                      }}
                    />
                  </Tooltip>
                </span>
              }
              name="currency"
              rules={[
                {
                  required: true,
                  message: "Please select product currency",
                },
              ]}
            >
              <Select
                placeholder="Select currency"
                style={{ height: 44 }}
                suffixIcon={<ChevronDown color="#667085" width={20} />}
                showSearch
              >
                {currencyOptions.map((currency) => (
                  <Option key={currency.value} value={currency.value}>
                    {currency.label}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <span>
                  Issue Type
                  <Tooltip title="Select the issue type">
                    <InfoCircleOutlined
                      style={{
                        marginLeft: "4px",
                        color: "#667085",
                      }}
                    />
                  </Tooltip>
                </span>
              }
              name="issueType"
              rules={[
                {
                  required: true,
                  message: "Please select issue type",
                },
              ]}
            >
              <Select
                placeholder="Select issue type"
                style={{ height: 44 }}
                suffixIcon={<ChevronDown color="#667085" width={20} />}
                options={issueTypeOptions}
              />
            </Form.Item>
          </Col>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <span>
                  Bond Type
                  <Tooltip title="Select the bond type">
                    <InfoCircleOutlined
                      style={{
                        marginLeft: "4px",
                        color: "#667085",
                      }}
                    />
                  </Tooltip>
                </span>
              }
              name="bondType"
              rules={[
                {
                  required: true,
                  message: "Please select bond type",
                },
              ]}
            >
              <Select
                placeholder="Select bond type"
                style={{ height: 44 }}
                suffixIcon={<ChevronDown color="#667085" width={20} />}
                options={bondTypeOptions}
              />
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <span>
                  Accounting Classification
                  <Tooltip title="Select accounting Classification">
                    <InfoCircleOutlined
                      style={{
                        marginLeft: "4px",
                        color: "#667085",
                      }}
                    />
                  </Tooltip>
                </span>
              }
              name="accountingClassification"
              rules={[
                {
                  required: true,
                  message: "Please select accounting classification",
                },
              ]}
            >
              <Select
                options={accountingClassificationsOptions}
                placeholder={"Select accounting classification"}
                style={{ height: 44 }}
                showSearch
              />
            </Form.Item>
          </Col>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <span>
                  Custodian
                  <Tooltip title="Select custodian">
                    <InfoCircleOutlined
                      style={{
                        marginLeft: "4px",
                        color: "#667085",
                      }}
                    />
                  </Tooltip>
                </span>
              }
              name="custodian"
              rules={[
                {
                  required: true,
                  message: "Please select custodian",
                },
              ]}
            >
              <Select
                options={custodianOptions}
                placeholder={"Select custodian"}
                style={{ height: 44 }}
                suffixIcon={<ChevronDown color="#667085" width={20} />}
                showSearch
              />
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              name="startDate"
              label="Start Date"
              rules={[
                {
                  required: true,
                  message: "Start date is required",
                },
                {
                  validator: (_, value) => {
                    if (
                      !value ||
                      value.isAfter(startOfYear) ||
                      value.isSame(startOfYear, "day")
                    ) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error(
                        `Please select a date from ${startOfYear.format(
                          "YYYY-MM-DD"
                        )} onwards`
                      )
                    );
                  },
                },
              ]}
            >
              <DatePicker
                className="bond-date-picker"
                disabledDate={BOM.DisabledAfterCurrentDate}
                size="small"
                style={{
                  width: "100%",
                  height: 44,
                  display: "flex",
                  alignItems: "center",
                  padding: "0 11px",
                  fontSize: 14,
                }}
                suffixIcon={<CalendarIcon color="#667085" width={20} />}
              />
            </Form.Item>
          </Col>

          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              name="endDate"
              label="End Date"
              rules={[
                {
                  required: true,
                  message: "End date is required",
                },
                {
                  validator(_, value) {
                    if (!value) {
                      return Promise.reject(new Error(`End date is required`));
                    }
                    if (value?.isBefore(today, "day")) {
                      return Promise.reject(
                        new Error(
                          `End date cannot be lesser than ${today.format(
                            "YYYY-MM-DD"
                          )} (Today)`
                        )
                      );
                    }
                    return Promise.resolve();
                  },
                },
              ]}
            >
              <DatePicker
                className="bond-date-picker"
                style={{
                  width: "100%",
                  height: 44,
                  display: "flex",
                  alignItems: "center",
                  padding: "0 11px",
                  fontSize: 14,
                }}
                suffixIcon={<CalendarIcon color="#667085" width={20} />}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default EditProductInformationForm;
